import { createSelector } from 'reselect';

const selectLMSModules = (state: any) => state.lmsModules;

export const selectLMSModulesCurrentItem = createSelector([selectLMSModules], (lmsModules) => lmsModules.current);

export const selectLMSModulesListItems = createSelector([selectLMSModules], (lmsModules) => lmsModules.list);

export const selectLMSModulesItemById = (itemId: any) =>
    createSelector(selectLMSModulesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLMSModulesQueryItems = createSelector([selectLMSModules], (lmsModules) => lmsModules.query);

export const selectLMSModulesCreatedItem = createSelector([selectLMSModules], (lmsModules) => lmsModules.create);

export const selectLMSModulesUpdatedItem = createSelector([selectLMSModules], (lmsModules) => lmsModules.update);

export const selectLMSModulesReadItem = createSelector([selectLMSModules], (lmsModules) => lmsModules.read);

export const selectLMSModulesDeletedItem = createSelector([selectLMSModules], (lmsModules) => lmsModules.delete);

export const selectLMSModulesSearchedItems = createSelector([selectLMSModules], (lmsModules) => lmsModules.search);

export const selectLMSModulesItemsCount = createSelector([selectLMSModules], (lmsModules) => lmsModules.count);

export const selectLMSModulesItemsFilter = createSelector([selectLMSModules], (lmsModules) => lmsModules.filter);
